import { StyledTextField, styledTextFieldClasses } from "./HyroTextField.styles";
import React from "react";
import FieldCopy from "src/components/widgets/FieldCopyPaste/FieldCopy";
import { useTheme } from "@mui/material";

const HyroTextField = ({ ...props }) => {
  const theme = useTheme();
  const { InputProps, value, isFieldReadOnlyFromSpec, showCopyButton = true } = props;

  const isCopyButtonVisible = showCopyButton && value;

  return <StyledTextField {...props}
    allowTextCursor={true}
    slotProps={{
      input: {
        ...InputProps,
        endAdornment: (
          <>
            {InputProps?.endAdornment}
            {isCopyButtonVisible ? (
              <span className={styledTextFieldClasses.copyIcon}>
                <FieldCopy type={isFieldReadOnlyFromSpec ? "elevated" : "flat"}
                  useWrapper
                  zIndex={theme.zIndex.drawer + 1}
                  value={value}
                  iconSize={16}
                  buttonSize={32}
                />
              </span>
            ) : null}
          </>
        )
      }
    }}
  />;
};

export default HyroTextField;
